<div class="reportFraudWrapper">
    <div class="reportFraudView">
        <form autocomplete="off" [formGroup]="fraudsForm" method="post" (ngSubmit)="doSaveReportFraudsDetails()">

            <div class="form-group">
                <label for="ddlReportFraudTypeID">Select Report</label>
                <select class="form-control" id="ddlReportFraudTypeID" formControlName="ReportFraudTypeID">
                    <option value="">Select Report</option>
                    <option *ngFor="let fraud of fraudList" value="{{fraud.ReportFraudTypeID}}">{{ fraud.FraudNature }}</option>
                </select>
            </div>

            <div class="form-group">
                <label for="txtRemarks">Enter Remarks</label>
                <textarea class="form-control" id="txtRemarks" formControlName="Remarks"></textarea>
            </div>

            <div class="form-group">
                <input type="submit" value="Submit" class="btn btn-primary" />
            </div>

        </form>
    </div>  
</div>